<template>
  <div>
    <gmap-map
      :options="{
        zoomControl: true,
        streetViewControl: false,
        mapTypeId: 'satellite'
      }"
      :center="center"
      :zoom="12"
      :heading="90"
      :tilt="45"
      style="width: 100%; height: 400px"
      map-style-id="roadmap"
      @click="handleMapClick"
    >
      <gmap-info-window
        :options="infoOptions"
        :position="infoPosition"
        :opened="infoOpened"
        @closeclick="infoOpened = false"
      >
        <div v-html="infoContent" />
      </gmap-info-window>
      <gmap-marker
        :key="index"
        :icon="getColor(item)"
        v-for="(item, index) in markers"
        :position="getPosition(item)"
        :clickable="true"
        :draggable="disableEdit ? false : item.new"
        @dragend="handleMarkerDrag($event, index)"
        @click="toggleInfo(item, index)"
      ></gmap-marker>
    </gmap-map>
  </div>
</template>

<script>
export default {
  name: "GoogleMap",
  props: {
    setLocalEmit: {
      type: String,
      default: ""
    },
    markers: {
      type: Array,
      defaul: []
    },
    disableEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      center: { lat: 45.508, lng: -73.587 },
      onClick: false,
      currentPlace: null,
      infoPosition: null,
      infoContent: null,
      infoOpened: false,
      infoCurrentKey: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      }
    };
  },

  mounted() {
    this.setCenter();
  },

  methods: {
    setCenter() {
      if (!this.markers || this.markers.length <= 0) {
        this.geolocate();
        return;
      }

      let lat = this.markers[0].lat;
      let lng = this.markers[0].lng;
      this.center = { lat: lat, lng: lng };
    },
    getColor(item) {
      if (item.label.toLowerCase().includes("plantio"))
        return "https://maps.google.com/mapfiles/ms/icons/blue-dot.png";

      if (item.result >= 0 && item.result <= 20)
        return "https://maps.google.com/mapfiles/ms/icons/green-dot.png";

      if (item.result >= 21 && item.result <= 40)
        return "https://maps.google.com/mapfiles/ms/icons/yellow-dot.png";

      if (item.result >= 41 && item.result <= 60)
        return "https://maps.google.com/mapfiles/ms/icons/orange-dot.png";

      //>= 61
      return "https://maps.google.com/mapfiles/ms/icons/red-dot.png";
    },
    handleMarkerDrag(e, index) {
      if (!this.setLocalEmit) return;
      if (this.disableEdit)
        return;

      this.markers[index].lat = e.latLng.lat();
      this.markers[index].lng = e.latLng.lng();

      this.$emit(
        this.setLocalEmit,
        this.markers[index].lat,
        this.markers[index].lng
      );
    },
    handleMapClick(e) {
      if (!this.setLocalEmit) return;

      if (this.markers.filter((x) => x.new).length > 0) return;

      var a = {
        lat: e.latLng.lat(),
        lng: e.latLng.lng(),
        label: "NOVO",
        new: true
      };
      this.markers.push(a);
      this.$emit(this.setLocalEmit, a.lat, a.lng);
    },
    getPosition: function (marker) {
      return {
        lat: parseFloat(marker.lat),
        lng: parseFloat(marker.lng)
      };
    },
    toggleInfo: function (marker, key) {
      this.infoPosition = this.getPosition(marker);
      this.infoContent = marker.label;
      if (this.infoCurrentKey == key) {
        this.infoOpened = !this.infoOpened;
      } else {
        this.infoOpened = true;
        this.infoCurrentKey = key;
      }
    },
    setPlace(place) {
      this.currentPlace = place;
    },
    geolocate: function () {
      navigator.geolocation.getCurrentPosition((position) => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
      });
    }
  }
};
</script>